import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'
import Router from 'next/router'

import Boutton from '@piconetworks/pkg-boutton'
import ContentSection from 'components/ContentSection'
import DonationBoxesList from './DonationBoxesList'
import ProductsModule from 'modules/products'

import styles from '../Products.module.scss'

import { contributionBinPluralCapitalized, contributionBinSingularLowerCase, contributionBinSingularSlug } from 'features/ContributionLang'
import { useFeatureManager, constants } from 'features/FeatureManager'
import { usePlatformAccessPaywall } from 'features/platformAccess'

const DonationBoxes = () => {
    const data = useSelector(ProductsModule.selectors.getDonationBoxes)
    const loading = useSelector(ProductsModule.selectors.getProductsLoading)


    const { hasFeature } = useFeatureManager()
    const { openPlatformAccessPaywall, Paywall } =  usePlatformAccessPaywall()
    const hasDonations = hasFeature(constants.PRODUCT_TIP_JARS_FEATURE)

    return (
        <>
            <Paywall />
            <ContentSection.Child className={styles.child}>
                <section className={styles.productsHeader}>
                    <ContentSection.Header>{contributionBinPluralCapitalized()}</ContentSection.Header>
                    <Boutton
                        icon={<span className={cx('icon-icon_add', styles.icon)} />}
                        variant="secondary"
                        onClick={() => hasDonations ? Router.push('/products/edit/[type]/[id]', `/products/edit/${contributionBinSingularSlug()}/new`, { shallow: true }) : openPlatformAccessPaywall(constants.PRODUCT_TIP_JARS_FEATURE)}
                        className={styles.newButton}
                    >
                    New {contributionBinSingularLowerCase()}
                    </Boutton>
                </section>
            </ContentSection.Child>
            <ContentSection.Child className={cx(
                styles.child,
                {
                    [styles.empty] : !data.length
                }
            )}>
                <DonationBoxesList items={data} loading={loading} />
            </ContentSection.Child>
        </>
    )
}

export default DonationBoxes